import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { ShieldCheck, AlertTriangle } from "lucide-react";

export default function Safety() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/safety-notices").then(({ data }) => setData(data)).catch(() => setData({ notices: [] })); }, []);

  return (
    <div className="mx-auto max-w-2xl" data-testid="safety-page">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-mint"><ShieldCheck className="h-6 w-6 text-emerald-800" /></div>
        <h1 className="font-serif text-3xl font-bold text-emerald-950 sm:text-4xl">Safety &amp; scam warnings</h1>
      </div>

      {data === null ? <div className="mt-6 space-y-3">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-20 rounded-2xl" />)}</div> : (
        <>
          {data.contactWarning && (
            <div className="mt-6 flex items-start gap-3 rounded-2xl border border-amber-300 bg-amber-50 p-4" data-testid="safety-contact-warning">
              <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
              <p className="text-sm text-amber-900">{data.contactWarning}</p>
            </div>
          )}
          <div className="mt-4 space-y-3" data-testid="safety-notices">
            {(data.notices || []).map((n, i) => (
              <div key={i} className="rounded-2xl border border-emerald-900/10 bg-white p-5" data-testid={`safety-notice-${i}`}>
                <p className="font-semibold text-emerald-900">{n.title}</p>
                <p className="mt-1 text-sm text-slate-600">{n.body}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
